module.exports = function(app) {
    app.factory('userService', ['$http', '$q','services', 'invisibleForm', 'brand',
        function($http, $q, services, invisibleForm, brand) {
            window.services = services;

            var _formatDate,
                getIdentifyUserPayload,
                identifyUser,
                getMaskedUserEmail,
                getMaskedUserPhone,
                sendUsernameEmail,
                requestVerificationCode,
                verifyCode,
                getPasswordRules,
                submitNewPasswordAndUnlock,
                loginUser,
                showFooterMessage,
                showGeneralErrorMessage,
                parseBaseMessage;

            identifyUser = function(userSelection, isAccountRecoveryActive, payload) {
                var identifyUserPromise;

                if (isAccountRecoveryActive && (userSelection === 'member' || userSelection === 'visitor')) {
                    var deferred = $q.defer();

                    services.rbsmbl.identifyUser({role: userSelection}).postData(payload).then(
                        function(response) {
                            var userResponse = services.rbsmbl.identifyUser().parse(response);

                            if (userResponse && ((userSelection === 'member' && userResponse.userLogin && userResponse.userEmail) || (userSelection === 'visitor'))) {
                                var userObject = {
                                    user: {
                                        userToken: (userSelection === 'member' ? userResponse.userLogin.userToken : userResponse.userToken),
                                        userName: (userSelection === 'member' ? userResponse.userLogin.userName : userResponse.userName),
                                        userType: (userSelection === 'member' ? userResponse.userLogin.userType : userResponse.userType),
                                        email: (userSelection === 'member' ? userResponse.userEmail.email :  payload.email),
                                        verified: (userSelection === 'member' ? userResponse.userEmail.verified :  0)
                                    }
                                };
                                deferred.resolve(userObject);
                            } else {
                                deferred.reject("INVALID_RESPONSE");
                            }
                        }, function(error) {
                            deferred.reject(error);
                        }
                    );

                    identifyUserPromise = deferred.promise;
                } else {
                    identifyUserPromise = $http({
                        url: "/rbsmbl/x-services/user/securityQuestion",
                        method: "POST",
                        data: payload
                    });
                }
                return identifyUserPromise;
            };

            getIdentifyUserPayload = function(userSelection, isAccountRecoveryActive, data) {
                var payload = {};
                var dateFormat = "";

                var request = {
                    baseMessage: {
                        "headerVersion": "1.0",
                        "payloadVersion": "2.0",
                        "additionalInfo": null
                    },
                    payload: { }
                };

                if (isAccountRecoveryActive && (userSelection === 'member' || userSelection === 'visitor')) {
                    dateFormat = 'YYYY-MM-DD';
                    request = payload;
                } else {
                    request.payload = payload;
                }



                if (userSelection === "member") {
                    function _stripCharacters(memberID, characters) {
                        var theID = memberID;
                        while (characters.length) {
                            theID = theID.replace(characters.pop(), "");
                        }
                        return theID;
                    }

                    if (isAccountRecoveryActive) {
                        payload.dateOfBirth = _formatDate(data.member.dob, dateFormat);
                        payload.umi = data.member.id;

                        var isMN = brand.current.ubk == 6010;
                        var isND = brand.current.ubk == 6011;
                        var alphaCharacters = payload.umi.match(/[A-Za-z]/g) || [];

                        if (isMN || isND) {
                            delete payload.umi;

                            if (alphaCharacters.length == 2) {
                                payload.clientAssignedId = data.member.id;
                            } else if (alphaCharacters.length == 5) {
                                var theId = data.member.id;

                                for (var i = 0; i < 3; i++) {
                                   theId = theId.replace(alphaCharacters[i], "");
                                }

                                payload.clientAssignedId = theId;
                            } else {
                                payload.umi = _stripCharacters(data.member.id, alphaCharacters);
                            }
                        } else {
                            payload.umi = _stripCharacters(payload.umi, alphaCharacters);
                        }
                    } else {
                        payload.role = "MEMBER";
                        payload.birthDate = _formatDate(data.member.dob, dateFormat);
                        payload.memberId = data.member.id;
                    }
                    payload.firstName = data.member.firstName.toUpperCase();

                } else if (userSelection === "visitor") {
                    if (isAccountRecoveryActive) {
                        payload.dateOfBirth = _formatDate(data.visitor.dob, dateFormat);
                    } else {
                        payload.role = "VISITOR";
                        payload.birthDate = _formatDate(data.visitor.dob, dateFormat);
                    }
                    payload.firstName = data.visitor.firstName.toUpperCase();
                    payload.lastName = data.visitor.lastName.toUpperCase();
                    payload.email = data.visitor.emailAddress.toUpperCase();

                } else if (userSelection === "producer") {
                    payload.role = "AGENT";
                    payload.email = data.producer.agentEmail;

                } else if (userSelection === "agency") {
                    payload.role = "AGENCY_ADMIN";
                    payload.firstName = data.agency.firstName.toUpperCase();
                    payload.lastName = data.agency.lastName.toUpperCase();
                    payload.memberId = data.agency.agencyNumber;

                } else {
                    return;
                }

                return request;
            };

            _formatDate = function(date, format) {
                //formats DOB
                var dob = date;
                var month = dob.getMonth() + 1;
                var day = dob.getDate();

                if (month < 10) {
                    month = '0' + month;
                }
                if (day < 10) {
                    day = '0' + day;
                }

                if (format === 'YYYY-MM-DD') {
                    return (dob.getFullYear() + '-' + month + '-' + day);
                } else {
                    return (month + '/' + day + '/' + dob.getFullYear());
                }
            };

            getMaskedUserEmail = function(userToken, userType) {
                var type = (userType ? userType.toLowerCase() : "member");
                return services.rbsmbl.maskedEmail({ userType: type }).fetch(userToken);
            };

            getMaskedUserPhone = function(userToken, userType) {
                var deferred = $q.defer();

                var type = (userType ? userType.toLowerCase() : "member");

                services.rbsmbl.maskedPhone({ userType: type }).fetch(userToken).then(function(response) {
                    deferred.resolve(response);
                }, function(error) {
                    deferred.resolve({ error: error });
                });
                return deferred.promise;
            };

            sendUsernameEmail = function(userToken) {
                var payload = {
                    "userToken": userToken
                };
                return services.rbsmbl.emailUsername().postData(payload);
            };

            requestVerificationCode = function(userToken, contactJSON) {
                var contact  = JSON.parse(contactJSON);
                var payload = {
                    "userToken": userToken
                };

                if (contact.communicationMethod === 'sms') {
                    payload = {
                        "phoneNumber": { "type": contact.type },
                        "userLogin" : { "userToken":  userToken }
                    };
                }

                return services.rbsmbl.verificationCode({ type: contact.communicationMethod }).requestCode(payload);
            };

            verifyCode = function(userToken, verificationCode) {
                var deferred = $q.defer();

                services.rbsmbl.verificationCode({ type: 'match' }).matchCode(userToken, verificationCode).then(function(response) {
                    deferred.resolve(response);
                }, function(error) {
                    deferred.resolve({ error: error });
                });
                return deferred.promise;
            };

            getPasswordRules = function(userToken) {
                return services.rbsmbl.userPasswordRules().fetch(userToken);
            },

            submitNewPasswordAndUnlock = function(userToken, verificationCode, newPassword) {
                var payload = {
                    "userVerification" : {
                        "code": verificationCode
                    },
                    "userLogin": {
                        "userToken": userToken,
                        "password": newPassword
                    }
                };
                return services.rbsmbl.accountResetAndUnlock().putData(payload);
            };

            loginUser = function(username, password) {
                var deferred = $q.defer();
                services.rbsmbl.loginversion().fetch(username).then(function(response) {

                    if (response && response.data && response.data.payload) {

                        if (response.data.payload.loginVersion === 'MER_LOGIN_V1') {

                            services.rbsmbl.login().loginWithRedirect(username, response.data.payload.convertCase ? password.toUpperCase() : password).then(function(response2) {
                                deferred.resolve();
                            }, function(error) {
                                deferred.reject(error);
                            });
                        } else {
                            deferred.resolve();
                            invisibleForm.submit({
                                name: "loginForm",
                                action: '/chmptl/chm/jsp/logon.do',
                                inputs: {
                                    loginid: username,
                                    password: response.data.payload.convertCase ? password.toUpperCase() : password
                                }
                            });
                        }
                    } else {
                        deferred.reject({});
                    }
                }, function(error) {
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            showFooterMessage = function(footerMessage, headerText, messageText, isError) {
                footerMessage.header = headerText;
                footerMessage.message = messageText;
                footerMessage.iconClass = (isError ? "icon-alert red" : "icon-approved");
                footerMessage.show = true;
            };

            parseBaseMessage = function(response) {
                if (response && response.data && response.data.baseMessage) {
                    return response.data.baseMessage;
                }
                if (response && response.error && response.error.data && response.error.data.baseMessage) {
                    return response.error.data.baseMessage;
                }
            };

            return {
                identifyUser: identifyUser,
                getIdentifyUserPayload: getIdentifyUserPayload,
                getMaskedUserEmail: getMaskedUserEmail,
                getMaskedUserPhone: getMaskedUserPhone,
                sendUsernameEmail: sendUsernameEmail,
                requestVerificationCode: requestVerificationCode,
                verifyCode: verifyCode,
                getPasswordRules: getPasswordRules,
                submitNewPasswordAndUnlock: submitNewPasswordAndUnlock,
                loginUser: loginUser,
                showFooterMessage: showFooterMessage,
                parseBaseMessage: parseBaseMessage
            };
        }
    ]);
};